exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#divDadosPagador > div {\n    padding: 5px;\n}\n\n@media (max-width: 600px) {\n    #divDadosPagador > div {\n        width: 100%\n    }\n}\n", ""]);

